module.exports = __webpack_public_path__ + "static/media/steve.97f994fd.jpeg";